export default __webpack_public_path__ + "static/media/gallery-4.c6863dba.jpg";